var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h3',[_vm._v("(404) Page Not Found")]),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Go to home")]),_c('h3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }